import { colors } from '../../colors';
var address = {
  arrowColor: colors.cerulean,
  textColor: colors.onyx,
  borderColor: colors.onyx,
  backgroundColor: colors.whiteish
};
export default address;